"use client";
import SvgSkodaSymbol from "./skoda_symbol.svg.js";
import SvgSkodaWordmark from "./skoda_wordmark.svg.js";
const skoda = {
  key: "skoda",
  symbol: SvgSkodaSymbol,
  wordmark: SvgSkodaWordmark
};
export {
  skoda
};
